import { render, staticRenderFns } from "./Servico.vue?vue&type=template&id=d7b8c83e&scoped=true&"
import script from "./Servico.vue?vue&type=script&lang=js&"
export * from "./Servico.vue?vue&type=script&lang=js&"
import style0 from "./Servico.vue?vue&type=style&index=0&id=d7b8c83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b8c83e",
  null
  
)

export default component.exports